import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MainLayout from '../../layout/MainLayout';
import CenteredLayout from '../../layout/CenteredLayout';
import ProjectAppbar from '../../customComponents/ProjectAppbar';
import YouTubePlayer from '../../components/YouTubePlayer';
import { useLang } from '../../context/LangContext';

interface LiveWatchLocationState {
  url?: string;
}

const liveWatchTexts = {
  ko: {
    title: '라이브 보기',
    invalidUrl: '라이브 스트림 URL을 불러올 수 없습니다.',
    goBack: '이전으로',
  },
  en: {
    title: 'Watch Live',
    invalidUrl: 'Unable to load live stream URL.',
    goBack: 'Go Back',
  },
};

function LiveWatch() {
  const navigate = useNavigate();
  const location = useLocation();
  const { lang } = useLang();
  const texts = liveWatchTexts[lang];

  const state = (location.state || {}) as LiveWatchLocationState;
  const url = state.url;

  const [isLoaded, setIsLoaded] = useState(false);
  const [showOpenInNewTab, setShowOpenInNewTab] = useState(false);

  const handleBack = () => {
    // 히스토리가 없을 때를 대비해 홈으로 fallback
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/', { replace: true });
    }
  };

  // iframe이 일정 시간 내에 로드되지 않으면 새 탭 열기 버튼 노출
  useEffect(() => {
    if (!url) return;

    setIsLoaded(false);
    setShowOpenInNewTab(false);

    const timer = setTimeout(() => {
      if (!isLoaded) {
        setShowOpenInNewTab(true);
      }
    }, 4000);

    return () => clearTimeout(timer);
  }, [url, isLoaded]);

  const handleOpenInNewTab = () => {
    if (!url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const isYouTubeUrl = url ? /youtube\.com|youtu\.be/.test(url) : false;

  return (
    <MainLayout>
      <CenteredLayout>
        <ProjectAppbar
          currentPage="home"
          title={texts.title}
          showBackButton={true}
          onBack={handleBack}
        />
        <div
          style={{
            padding: '0',
            margin: '0',
            width: '100%',
            marginTop: '60px',
            height: 'calc(100dvh - 60px)',
            maxWidth: '100%',
            position: 'relative',
          }}
        >
          {url ? (
            isYouTubeUrl ? (
              <YouTubePlayer youtubeUrl={url} />
            ) : (
              <>
                <iframe
                  src={url}
                  title="live-view"
                  style={{
                    border: 'none',
                    width: '100%',
                    height: '100%',
                  }}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  onLoad={() => setIsLoaded(true)}
                />
                {showOpenInNewTab && (
                  <div
                    style={{
                      position: 'absolute',
                      bottom: 16,
                      left: 0,
                      right: 0,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      pointerEvents: 'none',
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: 'rgba(0,0,0,0.6)',
                        color: '#fff',
                        padding: '8px 12px',
                        borderRadius: 8,
                        fontSize: 12,
                        marginBottom: 8,
                        pointerEvents: 'auto',
                      }}
                    >
                      화면이 보이지 않으면 아래 버튼으로 새 탭에서 열어주세요.
                    </div>
                    <button
                      onClick={handleOpenInNewTab}
                      style={{
                        pointerEvents: 'auto',
                        padding: '10px 16px',
                        borderRadius: 999,
                        border: 'none',
                        backgroundColor: '#ffffff',
                        color: '#333',
                        fontSize: 14,
                        cursor: 'pointer',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
                      }}
                    >
                      새 탭에서 열기
                    </button>
                  </div>
                )}
              </>
            )
          ) : (
            <div
              style={{
                padding: '40px 16px',
                textAlign: 'center',
                color: '#666',
                fontSize: 14,
                height: '100%',
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <p>{texts.invalidUrl}</p>
              <button
                onClick={handleBack}
                style={{
                  marginTop: 16,
                  padding: '10px 16px',
                  borderRadius: 8,
                  border: 'none',
                  backgroundColor: '#333',
                  color: '#fff',
                  fontSize: 14,
                  cursor: 'pointer',
                }}
              >
                {texts.goBack}
              </button>
            </div>
          )}
        </div>
      </CenteredLayout>
    </MainLayout>
  );
}

export default LiveWatch;
